import React from 'react';
import { withRouter } from 'react-router-dom';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts';
import './ValuesByPaymentOperator.css';
import { injectIntl } from 'react-intl';
import messages from './ValuesByPaymentOperator.intl';

const ValuesByPaymentOperator = (props) => {
    const { intl } = props;
    const colors = props.colors;
    const data = props.data.data.data.map((data) => {
        const tratada = { date: data.date };
        for (let i = 0; i < data.values.length; i++) {
            tratada[data.values[i].name] = data.values[i].value;
        }
        return tratada;
    });
    const values = props.data.data.dataValueNames;
    const tickFormatter = (number) => {
        if (number > 1000000000) {
            return `$${(number / 1000000000).toString()}B`;
        }
        if (number > 1000000) {
            return `$${(number / 1000000).toString()}M`;
        }
        if (number > 1000) {
            return `$${(number / 1000).toString()}K`;
        }
        return `$${number.toString()}`;
    };
    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div className='custom-tooltip'>
                    <p>{`${payload[0].payload.date}`}</p>
                    {payload.map((payload) => {
                        const color = payload.color;
                        return (
                            <p key={payload.name} style={{ color }}>{`${
                                payload.name
                            } : ${payload.value.toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                            })}`}</p>
                        );
                    })}
                </div>
            );
        }

        return null;
    };
    return (
        <>
            <div className='text'>
                <h1>{intl.formatMessage(messages.valuesByPaymentOperator)}</h1>
            </div>

            <div className='chart chart-line'>
                <ResponsiveContainer
                    width={window.screen.width / 3}
                    height={500}
                >
                    <BarChart
                        width={400}
                        height={500}
                        data={data}
                        margin={{
                            top: 20,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray='1 1' />
                        <XAxis tick={{ fontSize: 13 }} dataKey='date' />
                        <YAxis tickFormatter={tickFormatter} />
                        <Tooltip content={CustomTooltip} />
                        <Legend />
                        {values.map((value, index) => {
                            return (
                                <Bar
                                    key={value}
                                    name={value}
                                    dataKey={value}
                                    stackId='a'
                                    fill={colors[index]}
                                />
                            );
                        })}
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </>
    );
};

export default injectIntl(withRouter(ValuesByPaymentOperator));
